import { Component } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from '../../services/analytics.service';
import { PresaleDataService } from '../../services/connection-services/data.service';
import { CHAINS } from '../../shared/constants/app-enums';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
})
export class BannerComponent {
  lang: string = '';
  walletAddress!: string;

  constructor(
    private translate: TranslateService,
    private dataService: PresaleDataService,
  private analyticsService: AnalyticsService,
) {
    this.translate.onLangChange.subscribe((params: LangChangeEvent) => {
      this.lang = params.lang;
    });
    this.dataService.$walletAddress.subscribe((item) => {
      this.walletAddress = this.dataService?.activeChain === CHAINS.SOL ? this.dataService.walletAddressSOL : this.dataService.walletAddress
    })
  }
  connectModal(placement: 'Widget-Crypto' | 'Widget-Card'): void {
    if(!this.walletAddress  ){
      this.analyticsService.vwoData('walletConnectionPlacement', { placement });
      this.dataService.connectWallet();
    }
  }
}
